import { Button } from '../../../../../../components/Toolkit/Button/Button';
import { type RevealPhoneNumberProps } from '../../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { ShowNumberBottomSheet } from '../subcomponents/ShowNumberBottomSheet';
import { Columns } from '../../../../../../components/Toolkit/Columns/Columns';
import { EmailDealerOrSeller } from '../../EmailDealerOrSeller/EmailDealerOrSeller';

import { type EmailDealerOrSellerProps } from '../../EmailDealerOrSeller/EmailDealerOrSeller.typed';

import { useWhatsappAction } from '../subcomponents/useWhatsAppAction';
import { SELLER_TYPES } from '../../../types';

type Variant2Props = {
  phoneResponse: boolean;
  emailResponse: boolean;
  phoneContactProps: RevealPhoneNumberProps;
  emailSellerProps: EmailDealerOrSellerProps;
  whatsappResponse: boolean;
  adId: number;
  priceEuro?: number | null;
  sellerType?: string;
  sectionName?: string;
  price?: string | null;
};

type EmailCtaProps = {
  emailSellerProps: EmailDealerOrSellerProps;
  isPrivateSeller: boolean;
  phoneResponse: boolean;
  whatsappResponse: boolean;
};

const EmailCta = ({
  emailSellerProps,
  isPrivateSeller,
  phoneResponse,
  whatsappResponse,
}: EmailCtaProps) => (
  <EmailDealerOrSeller
    {...emailSellerProps}
    ofType={
      !isPrivateSeller && (phoneResponse || whatsappResponse)
        ? 'SECONDARY'
        : 'PRIMARY'
    }
  >
    {isPrivateSeller ? 'Message' : 'Email'}
  </EmailDealerOrSeller>
);

type WhatsappCtaProps = {
  isPrivateSeller: boolean;
  phoneResponse: boolean;
  emailResponse: boolean;
  onClick: () => void;
  isLoading: boolean;
};

const WhatsappCta = ({
  isPrivateSeller,
  phoneResponse,
  emailResponse,
  onClick,
  isLoading,
}: WhatsappCtaProps) => (
  <Button
    ofType={
      (isPrivateSeller ? emailResponse : phoneResponse)
        ? 'SECONDARY'
        : 'PRIMARY'
    }
    onClick={onClick}
    disabled={isLoading}
  >
    WhatsApp
  </Button>
);

type PhoneCtaProps = {
  phoneContactProps: RevealPhoneNumberProps;
  isPrivateSeller: boolean;
  emailResponse: boolean;
  whatsappResponse: boolean;
};

const PhoneCta = ({
  phoneContactProps,
  isPrivateSeller,
  emailResponse,
  whatsappResponse,
}: PhoneCtaProps) => (
  <ShowNumberBottomSheet
    key={phoneContactProps.adId}
    {...phoneContactProps}
    isPrimaryButton={
      isPrivateSeller
        ? !emailResponse && !whatsappResponse
        : phoneContactProps.isPrimaryButton
    }
  >
    Show phone
  </ShowNumberBottomSheet>
);

const Variant2 = (props: Variant2Props) => {
  const {
    emailResponse,
    emailSellerProps,
    phoneResponse,
    phoneContactProps,
    whatsappResponse,
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  } = props;

  const { onWhatsAppButtonClick, isLoading } = useWhatsappAction({
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  });

  const isPrivateSeller = sellerType === SELLER_TYPES.PRIVATE;

  const emailCtaProps = {
    emailSellerProps,
    isPrivateSeller,
    phoneResponse,
    whatsappResponse,
  };
  const whatsappCtaProps = {
    isPrivateSeller,
    phoneResponse,
    emailResponse,
    onClick: onWhatsAppButtonClick,
    isLoading,
  };
  const phoneCtaProps = {
    phoneContactProps,
    isPrivateSeller,
    emailResponse,
    whatsappResponse,
  };

  return isPrivateSeller ? (
    <Columns>
      {phoneResponse && <PhoneCta {...phoneCtaProps} />}
      {whatsappResponse && <WhatsappCta {...whatsappCtaProps} />}
      {emailResponse && <EmailCta {...emailCtaProps} />}
    </Columns>
  ) : (
    <Columns>
      {emailResponse && <EmailCta {...emailCtaProps} />}
      {whatsappResponse && <WhatsappCta {...whatsappCtaProps} />}
      {phoneResponse && <PhoneCta {...phoneCtaProps} />}
    </Columns>
  );
};

export { Variant2 };
